export default {
// ja-JP.js
help: {
  faq: "よくある質問",
  promo: "プロモ",
  contactUs: "お問い合わせ",
  joinCommunity: "コミュニティに参加",
  help: "ヘルプ"
}
};
